module.exports = __webpack_public_path__ + "img/20200613_094230.4c6cc9cf.jpg";